"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildtryExecuteAsync = void 0;
const try_execute_async_1 = require("./try-execute-async");
function buildtryExecuteAsync(errorHandler) {
    return async (fn, ...args) => await (0, try_execute_async_1.tryExecuteAsync)(errorHandler, fn, ...args);
}
exports.buildtryExecuteAsync = buildtryExecuteAsync;
